import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { Problem } from './components/Problem';
import { Integrations } from './components/Integrations';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Showcase } from './components/Showcase';
import { UseCases } from './components/UseCases';
import { SocialProof } from './components/SocialProof';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { CtaBand } from './components/CtaBand';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-cream text-ink" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBand data-id="element-4" />
        <Problem data-id="element-5" />
        <Integrations data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <Features data-id="element-8" />
        <Showcase data-id="element-9" />
        <UseCases data-id="element-10" />
        <SocialProof data-id="element-11" />
        <Pricing data-id="element-12" />
        <FAQ data-id="element-13" />
        <CtaBand data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}